export default "__VITE_ASSET__f6a49e83__"